import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Mapper } from '@core/services/mapper';
import { PermittedAccess } from '@features/fleets/models/permitted-access.model';
import { Observable, throwError } from 'rxjs';
import { ApiConstant } from '@shared/constants/api.constant';

@Injectable({ providedIn: 'root' })
export class PermitsApiService {
  constructor(private baseAPI: ApiBaseService, private mapper: Mapper) {}

  update(permit: PermittedAccess, truckId, driverId): Observable<any> {
    return truckId
      ? this.updateTruckPermit(permit, truckId)
      : driverId
        ? this.updateDriverPermit(permit, driverId)
        : throwError('id is not recognized');
  }

  updateDriverPermit(permit, driverId): Observable<any> {
    return this.baseAPI.put(ApiConstant.UPDATE_DRIVER_PERMIT + permit.id, {...permit, driverId});
  }

  updateTruckPermit(permit, truckId): Observable<any> {
    return this.baseAPI.put(ApiConstant.UPDATE_TRUCK_PERMIT + permit.id, {...permit, truckId});
  }
}
